import {FC} from 'react';

import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import {TypeAlign} from '../../../shared/types/table.types';

const headCells = [
  {
    disablePadding: false,
    id: 'id',
    label: '№',
    align: 'left',
    width: '65px',
  },
  {
    disablePadding: true,
    id: 'moderationNeeds',
    label: '',
    align: 'left',
    width: '30px',
  },
  {
    disablePadding: false,
    id: 'modelName',
    label: 'Название модели',
    align: 'left',
  },
  {
    disablePadding: false,
    id: 'operator',
    label: 'Мобильный оператор',
    align: 'left',
  },
  {
    disablePadding: false,
    id: 'createdYear',
    label: 'Год производства',
    align: 'left',
  },
  {
    disablePadding: false,
    id: 'serial',
    label: 'Заводской номер',
    align: 'left',
  },
  {
    disablePadding: false,
    id: 'ip',
    label: 'IP',
    align: 'left',
  },
  {
    disablePadding: false,
    id: 't1',
    label: 'T1',
    align: 'left',
  },
  {
    disablePadding: false,
    id: 't2',
    label: 'T2',
    align: 'left',
  },
  {
    disablePadding: false,
    id: 't3',
    label: 'T3',
    align: 'left',
  },
  {
    disablePadding: false,
    id: 'status',
    label: 'Статус',
    align: 'left',
  },
];

export const TableHeadContainer: FC = () => {
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.align as TypeAlign}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sx={{width: headCell.width}}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
